const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "forget":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "forget",
    reducer: reducer,
};

export default data;
